import { Typography } from '@mui/material';
import { ReferenceField } from 'react-admin';

import { Avatar } from '../suppliercontacts/Avatar';
import type { ActivityContactNoteCreated } from '../types';
import { BuyerName } from '../buyers/BuyerName';
import { ActivityLogNote } from './ActivityLogNote';
import { RelativeDate } from '../misc/RelativeDate';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogContactNoteCreatedProps = {
    activity: ActivityContactNoteCreated;
};

export function ActivityLogContactNoteCreated({
    activity,
}: ActivityLogContactNoteCreatedProps) {
    const context = useActivityLogContext();
    const { contactNote } = activity;
    return (
        <ActivityLogNote
            header={
                <>
                    <ReferenceField
                        source="id_fornec"
                        reference="suppliercontacts"
                        record={contactNote}
                        link={false}
                    >
                        <Avatar width={20} height={20} />
                    </ReferenceField>
                    <Typography
                        component="p"
                        variant="body2"
                        color="text.secondary"
                        flexGrow={1}
                    >
                        {contactNote.nome_usuario}{' '}
                        adicionou uma anotação a{' '}
                        <ReferenceField
                            source="id_pessoa"
                            reference="persons"
                            record={contactNote}
                        />
                        {context !== 'company' && (
                            <>
                                {' from '}
                                <ReferenceField
                                    source="id_fornec"
                                    reference="suppliercontacts"
                                    record={contactNote}
                                    link={false}
                                >
                                    <ReferenceField
                                        source="id_pessoa"
                                        reference="persons"
                                        link="show"
                                    />
                                </ReferenceField>{' '}
                                <RelativeDate date={activity.data_hora} />
                            </>
                        )}
                    </Typography>
                    {context === 'company' && (
                        <Typography
                            color="textSecondary"
                            variant="body2"
                            component="span"
                        >
                            <RelativeDate date={activity.data_hora} />
                        </Typography>
                    )}
                </>
            }
            text={contactNote.texto_atividade}
        />
    );
}
